import { IndexableType } from 'dexie'
import { GlobalIndexDbService, IGlobalDataDocMetadata } from './globalIndexDb.service'
import { IGlobalDataResponseDoc } from '../features/globalData/services/globalDataImport.service'

export type globalDataMetadata = Array<IGlobalDataDocMetadata>

export interface IGlobalDataDocBase {
  id: string
  lastUpdatedTime: string
}

export class GlobalDataMetadataService {
  private db: GlobalIndexDbService
  private tableName: string

  constructor() {
    this.db = new GlobalIndexDbService()
    this.tableName = this.db.metadataDataStore.name
  }

  async getAllDoc(): Promise<globalDataMetadata> {
    return await this.db.getAll(this.tableName)
  }

  async removeDoc(id: string): Promise<void> {
    return await this.db.remove(id, this.tableName)
  }

  async getDocument(id: string): Promise<IGlobalDataDocMetadata | undefined | null> {
    return await this.db.get(id, this.tableName)
  }

  async createDocument(document: IGlobalDataDocMetadata): Promise<IndexableType> {
    return this.db.addWithKey(document, this.tableName, document.id)
  }

  async updateDocument(document: IGlobalDataDocMetadata): Promise<IndexableType> {
    return this.db.update(document.id, document, this.tableName)
  }

  async createOrUpdateDocument(document: IGlobalDataDocMetadata) {
    return this.db.createOrUpdate(document.id, document, this.tableName)
  }

  async createOrUpdate(globalDataResponseDoc: IGlobalDataResponseDoc) {
    const metadataDoc: IGlobalDataDocMetadata = {
      id: globalDataResponseDoc.id,
      lastUpdatedTime: globalDataResponseDoc.lastUpdatedTime,
      docGroup: globalDataResponseDoc.docGroup,
      dataSize: globalDataResponseDoc.dataSize,
    }
    return this.db.createOrUpdate(globalDataResponseDoc.id, metadataDoc, this.tableName)
  }

  async isEmpty() {
    return this.db.isEmpty(this.tableName)
  }
}
